import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { buildMuiTheme } from './theme/muiTheme';
import { store } from './root/store';
import App from './App';
import { loadRuntimeConfig } from './config/runtimeConfig';
import { setApiBaseUrl } from './modules/api';

//locale
import './localization/i18n';

const themePreset = localStorage.getItem('muiThemePreset') || 'muiDashboardV7';
const appTheme = buildMuiTheme(themePreset);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

function renderApp() {
  root.render(
    <Provider store={store}>
      <MuiThemeProvider theme={appTheme}>
        <LegacyThemeProvider theme={appTheme}>
          <CssBaseline />
          <App />
        </LegacyThemeProvider>
      </MuiThemeProvider>
    </Provider>
  );
}

loadRuntimeConfig().then((config) => {
  if (config && config.apiBaseUrl) {
    setApiBaseUrl(config.apiBaseUrl);
  }
  renderApp();
});